import React, { useEffect, useState } from "react";
import {
  SUBSCRIPTION_DETAIL,
  SUBSCRIPTION_SUBSCRIBER,
} from "../../../../services/ApiCalls";
import { checkResponse } from "../../../../utilities/utilities";
import { Link, useParams } from "react-router-dom";
import Loading from "../../../../components/Common/Loading";
import { Container } from "react-bootstrap";
import { Col, Row } from "antd";
import TableLayout from "../../../../components/TableLayout";
import CustomPagination from "../../../../components/Common/CustomPagination";
import moment from "moment";

const ViewSubscription = () => {
  const { id } = useParams();
  const [getLoader, setGetLoader] = useState(false);
  const [data, setData] = useState();
  const [subscriber, setSubscriber] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [body, setBody] = useState({
    subscriptionId: id,
    page: page,
    limit: limit,
  });
  const [total, setTotal] = useState(0);
  useEffect(() => {
    if (id) {
      getSubscription(id);
    }
  }, [id]);
  const getSubscription = async (id) => {
    try {
      setGetLoader(true);
      const res = await SUBSCRIPTION_DETAIL(id);
      checkResponse({
        res,
        setData: (response) => {
          setData(response || null);
        },
        setLoader: setGetLoader,
      });
    } catch (error) {
      setGetLoader(false);
      console.error("Error fetching subscription:", error);
    }
  };

  useEffect(() => {
    if (id) {
      getSubscriberList(body);
    }
  }, [body]);
  const getSubscriberList = async () => {
    try {
      setGetLoader(true);
      const res = await SUBSCRIPTION_SUBSCRIBER(body);
      checkResponse({
        res,
        setData: (response) => {
          setSubscriber(response || null);
          setTotal(response?.totalRecord || 0);
          setLimit(response?.page || 0);
          setPage(response?.limit || 0);
        },
        setLoader: setGetLoader,
      });
    } catch (error) {
      setGetLoader(false);
      console.error("Error fetching subscribers:", error);
    }
  };
  const paginationHandler = (page) => {
    setBody((prev) => ({ ...prev, page }));
  };
  const column = [
    {
      head: "Name",
      accessor: "name",
      component: (item) => <>{item?.name}</>,
    },
    {
      head: "Email",
      accessor: "email",
      component: (item) => <>{item?.email}</>,
    },
    {
      head: "Phone",
      accessor: "phone",
      component: (item) => <>{item?.phone}</>,
    },
    {
      head: "CRNumber",
      accessor: "CRNumber",
      component: (item) => <>{item?.CRNumber}</>,
    },
    {
      head: "Date of Joining",
      accessor: "dateOfJoining",
      component: (item) => (
        <>{moment(item?.dateOfJoining).format("DD-MM-YYYY")}</>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      component: (item) => (
        <p
          className={`${
            item.status === "reject"
              ? "redStatus"
              : item.status === "Approve"
              ? "greenStatus"
              : ""
          } status m-0 rounded-pill px-3 text-capitalize py-1 fw-sbold`}
        >
          {item.status === "Approve" ? "Approve" : "Reject"}
        </p>
      ),
    },
  ];
  if (getLoader) {
    return (
      <div
        className="d-flex justify-content-center align-items-center mt-5"
        style={{ height: "100%" }}
      >
        <Loading />
      </div>
    );
  }
  if (!data) {
    return (
      <div className="p-4">
        <p>No subscription data found.</p>
      </div>
    );
  }

  // console.log(subscriber, "subscriber data===");
  // console.log(data, "subscription data===");
  // console.log(body, "body data===");
  // console.log(total, "total data===");
  // console.log(page, "page data===");
  // console.log(limit, "limit data===");


  return (
    <div>
      <section>
        <div className="d-flex align-items-center justify-content-between gap-10 mb-4">
          <div className="left d-flex align-items-center gap-10 pt-4 px-4">
            <Link to="/subscription" className="me-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="18"
                viewBox="0 0 14 24"
                fill="none"
              >
                <path
                  d="M13.2085 3.03579L4.33158 11.9032L13.2085 20.7706C13.5449 21.1067 13.7339 21.5624 13.7339 22.0376C13.7339 22.5128 13.5449 22.9686 13.2085 23.3046C12.8721 23.6406 12.4159 23.8294 11.9402 23.8294C11.4645 23.8294 11.0082 23.6406 10.6718 23.3046L0.527997 13.1702C0.360568 13.0043 0.227702 12.807 0.137077 12.5895C0.0464509 12.372 -0.000138658 12.1388 3.09972e-07 11.9032C3.09972e-07 11.4288 0.189391 10.9716 0.525128 10.6362L10.6704 0.503263C11.0086 0.176822 11.4615 -0.0038851 11.9318 6.33701e-05C12.402 0.00401184 12.8519 0.192299 13.1845 0.524373C13.5171 0.856446 13.7059 1.30574 13.7101 1.77547C13.7143 2.24521 13.5337 2.69781 13.2071 3.03579H13.2085Z"
                  fill="black"
                />
              </svg>
            </Link>
            <h4 className="mb-0 fw-bold text-capitalize px-0">
              Detail Subscription Plan
            </h4>
          </div>
        </div>

        <div className="mt-2 px-4">
          <div className="card shadow-sm w-100" style={{ maxWidth: "400px" }}>
            <div
              className="card-header text-white"
              style={{ backgroundColor: "#419A9F" }}
            >
              <h4 className="mb-0">Subscription Details</h4>
            </div>
            <div className="card-body">
              <p className="d-flex gap-2">
                <strong>Name:</strong> {data?.subscription?.name}
              </p>
              <p className="d-flex gap-2">
                <strong>Description:</strong> {data?.subscription?.description}
              </p>
              <p className="d-flex gap-2">
                <strong>Cost:</strong> SAR{" "}
                {data?.subscription?.cost?.toFixed(2)}
              </p>
              <p className="d-flex gap-2">
                <strong>Validity:</strong>{" "}
                {new Date(
                  data?.subscription?.validity?.from
                ).toLocaleDateString()}{" "}
                -{" "}
                {new Date(
                  data?.subscription?.validity?.to
                ).toLocaleDateString()}
              </p>
              <p className="d-flex gap-2">
                <strong>Status:</strong>
                <span
                  className={`badge p-2 ${
                    data?.subscription?.isActive ? "bg-success" : "bg-secondary"
                  }`}
                >
                  {data?.subscription?.isActive ? "Active" : "Inactive"}
                </span>
              </p>
            </div>
          </div>
        </div>

        <Container>
          <Row className="mb-2">
            <Col lg="12">
              <h4 className="py-3 fw-bold text-capitalize">
                Subscribe Daycare List
              </h4>
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <div
                className="cardCstm p-3 rounded bg-white"
                // style={{ minHeight: "300px" }}
              >
                <TableLayout
                  data={subscriber?.daycareSubscriptions}
                  column={column}
                  Loading={getLoader}
                />
                <CustomPagination
                  body={body}
                  total={total}
                  pageChangeHandler={paginationHandler}
                  setBody={setBody}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default ViewSubscription;
